import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnsXsComponent } from './columns/columns-xs/columns-xs.component';
import { ColumnsSmComponent } from './columns/columns-sm/columns-sm.component';
import { ColumnsMdComponent } from './columns/columns-md/columns-md.component';
import { ColumnsLgComponent } from './columns/columns-lg/columns-lg.component';
import { AngularMaterialModule } from 'src/app/shared/angular-material/angular-material.module';
import { ArticlePostComponent } from './component/article-post/article-post.component';
import { PipsModule } from 'src/app/shared/pips/pips.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProfileHeaderComponent } from './component/profile-header/profile-header.component';
import { ActionMenuComponent } from './component/action-menu/action-menu.component';
import { SidenavbarComponent } from './component/header/sidenavbar/sidenavbar.component';
import { EntityHeaderOptionComponent } from './component/header/entity-header-option/entity-header-option.component';
import { ConstContentComponent } from './columns/components/const-content/const-content.component';
import { MagazineBoxComponent } from './columns/components/magazine-box/magazine-box.component';
import { EntityBoxComponent } from './columns/components/entity-box/entity-box.component';
import { CategoryBoxComponent } from './columns/components/category-box/category-box.component';
import { RouterModule } from '@angular/router';
import { EntityTabMenuComponent } from './component/entity-tab-menu/entity-tab-menu.component';
import { EntityFlowBarComponent } from './component/entity-flow-bar/entity-flow-bar.component';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { SharedModule } from 'src/app/shared/components/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivityBoxComponent } from './columns/components/activity-box/activity-box.component';
import { AllExamComponent } from './component/all-acitvity-components/all-exam/all-exam.component';
import { AboutEntityComponent } from './component/about-entity/about-entity.component';
import { AboutListEntityComponent } from './component/about-list-entity/about-list-entity.component';
import { NotificationComponent } from './component/header/notification/notification.component';
import { FooterComponent } from './component/footer/footer.component';
import { HeaderComponent } from './component/header/header.component';
import { NotificationBoxComponent } from './columns/components/notification-box/notification-box.component';
import { EditProfileHeaderModalComponent } from './component/profile-header/edit-profile-header-modal/edit-profile-header-modal.component';
import { CategoryModalComponent } from './columns/components/category-box/category-modal/category-modal.component';
import { SortingModalComponent } from './columns/components/category-box/sorting-modal/sorting-modal.component';
import { PreviewModalComponent } from './columns/components/category-box/preview-modal/preview-modal.component';
import { SelectCategoryParentModalComponent } from './columns/components/category-box/select-category-parent-modal/select-category-parent-modal.component';
import { MobileCategoryBoxComponent } from './columns/components/mobile-category-box/mobile-category-box.component';
import { ColInfoMenuComponent } from './columns/components/col-info-menu/col-info-menu.component';
import { ToolsColumnComponent } from './component/tools-column/tools-column.component';
import { NotificateComponent } from './component/notificate/notificate.component';
import { AnalyzeNotificateComponent } from './component/analyze-notificate/analyze-notificate.component';
import { VisibilityComponent } from './component/about-list-entity/visibility/visibility.component';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    PipsModule,
    NgxSkeletonLoaderModule.forRoot(),
    RouterModule,
    DirectivesModule,
    SharedModule,
    ReactiveFormsModule,
    EditProfileHeaderModalComponent,
    FormsModule,
    
  ],
  exports:[
    ColumnsXsComponent,
    ColumnsSmComponent,
    ColumnsMdComponent,
    ColumnsLgComponent,
    ArticlePostComponent,
    ProfileHeaderComponent,
    ActionMenuComponent,
    SidenavbarComponent,
    EntityHeaderOptionComponent,
    ConstContentComponent,
    MagazineBoxComponent,
    EntityBoxComponent,
    CategoryBoxComponent,
    EntityTabMenuComponent,
    EntityFlowBarComponent,
    ActivityBoxComponent,
    AllExamComponent,
    NotificateComponent,
    AboutEntityComponent,
    AboutListEntityComponent,
    HeaderComponent,
    FooterComponent,
    NotificationBoxComponent,
    CategoryBoxComponent,
    SortingModalComponent,
    PreviewModalComponent,
    SelectCategoryParentModalComponent,
    ColInfoMenuComponent,
    ToolsColumnComponent,
    AnalyzeNotificateComponent
  ],
  declarations: [
    ColumnsXsComponent,
    ColumnsSmComponent,
    ColumnsMdComponent,
    ColumnsLgComponent,
    ArticlePostComponent,
    ProfileHeaderComponent,
    ActionMenuComponent,
    SidenavbarComponent,
    EntityHeaderOptionComponent,
    ConstContentComponent,
    MagazineBoxComponent,
    EntityBoxComponent,
    CategoryBoxComponent,
    EntityTabMenuComponent,
    EntityFlowBarComponent,
    ActivityBoxComponent,
    AllExamComponent,
    NotificateComponent,
    AboutEntityComponent,
    AboutListEntityComponent,
    NotificationComponent,
    HeaderComponent,
    FooterComponent,
    NotificationBoxComponent,
    CategoryModalComponent,
    SortingModalComponent,
    PreviewModalComponent,
    SelectCategoryParentModalComponent,
    MobileCategoryBoxComponent,
    ColInfoMenuComponent,
    ToolsColumnComponent,
    AnalyzeNotificateComponent,
    VisibilityComponent
  ]
})

export class LayoutModule { }